import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Grid, Hidden} from "@material-ui/core";
import { store } from "../../../../helpers/store";
import { makeStyles } from "@material-ui/core/styles";
import BillComparisonChart from "./_bill_compaarison_bar_chart";
import getBillComparison from "../model/e_bill_comparison_service";
import { appStyles } from "../../../app/app-style";
import { CircularProgress } from "@material-ui/core";
import {useTranslation} from 'react-i18next';
import {Skeleton} from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    noData: {
      color: theme.palette.ePrimary?.base,
      textAlign: "center",
      [theme.breakpoints.between("sm", "lg")]: {
        marginTop: "35%"
      },
      [theme.breakpoints.between("lg", "xl")]: {
        marginTop: "15%"
      },
    },
  headerColor : {
    color:theme.palette.ePrimary?.base,
},
    content : {
      alignContent:'center',
      align : 'center',
      marginRight:5,
  },
  bar:{
    marginTop:10,
    flexGrow: "1",
    height: "100%"
  },
  higher:{
    color :theme.palette.secondary.main,
  },
  lower:{
    color : appStyles.outerTheme.palette.eSecondary?.base,
  },
  same:{
    color: appStyles.outerTheme.palette.ePastelColor2?.base,
    fontSize: "0.75rem"
  },
  progress:{
    marginTop:"1rem"
  },
  mainGrid: {
    height: "100%", 
    flexFlow: "column"
  },
  contentGrid: {
    flexGrow: "1", 
    flexFlow: "column"
  }
  }));

  function E_BillComparisonView() {
    const BillComparisonClasses = useStyles();
    const {t:billComparisonLabels, ready: labelReady} = useTranslation("label-E_BILL_COMPARISON")
    const [loading, setLoading] = useState()
    const [BillData, setBillData] = useState();
    const accountId = useSelector((state) => state?.meterDetails?.accountId);
    let saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
      useEffect(() => {
        setLoading(true)
        if(saId && accountId){
          getBillComparison(saId,accountId)
          .then((response) => {
            setLoading(false)
            setBillData(response.data.getBillComparison);
          })
          .catch(err => {
            setBillData(null);
            setLoading(false)
          })
        }              
      }, [saId,accountId]);
      const [currentBillAmount,setCurrentData] = useState();
      const [previousBillAmount, setPreviousData] =useState()
      const [Higher,setHigher] =useState();
      const [lower, setLower] =useState();
      const [diffAmount,setDiffAmount] = useState()
      useEffect(()=>{
        if(BillData){
        setCurrentData(parseFloat(BillData?.[0]?.endingBalance));
        setPreviousData(parseFloat(BillData?.[1]?.endingBalance));
        }
      },[BillData])
      useEffect(()=>{
        if(currentBillAmount && previousBillAmount){
          setHigher(currentBillAmount > previousBillAmount);
        setLower(currentBillAmount < previousBillAmount);
        setDiffAmount(parseFloat(currentBillAmount - previousBillAmount).toFixed(2))
        }
      },[currentBillAmount,previousBillAmount])
      let comparison;
      if(Higher){
        comparison = labelReady ? billComparisonLabels('E_HIGHER') : ""
      }
      else if(lower){
        comparison = labelReady ? billComparisonLabels('E_LOWER') : ""
      }
      else{
        comparison = labelReady ? billComparisonLabels('E_SAME') : ""
      }
    return(
        <React.Fragment>
            <Grid container className={BillComparisonClasses.mainGrid}>
                <Grid item >
                {
                labelReady ?
                <Typography
                  variant="h6"
                  className = {BillComparisonClasses.headerColor}
                  align="left"
                >
                  <b>{billComparisonLabels("E_TITLE")}</b>
                </Typography>
                : <Skeleton />
                }
              </Grid>
              {
                BillData && previousBillAmount && currentBillAmount ? (
              <Grid item container className={BillComparisonClasses.contentGrid}>
              {
                labelReady ?
                <Typography
                  className = {BillComparisonClasses.content}
                  variant="subtitle2"
                >
                  {billComparisonLabels("E_YOUR_POWER_CHARGES_ARE_ABOUT")}{" "} 
                  {Higher || lower ? (<>{Higher ? <b className={BillComparisonClasses.higher}>{billComparisonLabels("E_CURRENCY")}{diffAmount}</b> : <b className={BillComparisonClasses.lower}>{billComparisonLabels("E_CURRENCY")}{diffAmount}</b>}</>):(null)} 
                  {" "}{Higher ? (<><b className={BillComparisonClasses.higher}>{comparison}</b></>) :null}{lower ? (<><b className={BillComparisonClasses.lower}>{comparison}</b></>) :null}{Higher === lower ? (<><b className={BillComparisonClasses.same}>{comparison}</b></>) :null} 
                  {" "}{billComparisonLabels("E_THAN_YOUR_PREVIOUS_BILL")}
                </Typography> 
                : <Skeleton />
              }
                      
                <Grid item align='center' justify='center' 
                className={BillComparisonClasses.bar}
                >
                <BillComparisonChart BillData ={BillData} currentBillAmount={currentBillAmount} previousBillAmount={previousBillAmount}/>
                </Grid>
              </Grid>
                ) :
                BillData && (!previousBillAmount || !currentBillAmount) ? (
                <Grid item xs={12} md={12} lg={12} display="flex" >
                {labelReady ?
                  <Typography variant="body1" align="center" 
                  className={BillComparisonClasses.noData}
                  >
                    {billComparisonLabels("E_PREV_BILL_NOT_AVAILABLE_MSG")}
                  </Typography>
                  : <Skeleton />}
                </Grid> ) :
                BillData === "undefined" || BillData===null ? (
                  <Grid item xs={12} md={12} lg={12}>(
                    labelReady ?
                    <Typography variant="subtitle1" align="center" className={BillComparisonClasses.noData}>{billComparisonLabels("E_BILL_COMPARISON_NO_DATA_FOUND")}</Typography>
                    <Skeleton />
                  </Grid>
                  ) :loading===true ? (
                    <><Grid item xs={12} md={12} lg={12} align="center" className={BillComparisonClasses.progress}>
                    <CircularProgress size={30} />
                  </Grid></>
                  ):(<><div></div></>)
              }
       </Grid>
    </React.Fragment>
    );
  }

  export default E_BillComparisonView;